module.exports = __webpack_public_path__ + "media/images/provider-logo-72eaa579d29acaec2140f0f53ef100ab.png";